import { render, staticRenderFns } from "./CourseTest.vue?vue&type=template&id=b9929ea0&"
import script from "./CourseTest.vue?vue&type=script&lang=js&"
export * from "./CourseTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports